import { heroBg } from "@/mocks/manga";

const stats = [
  { value: "860+", label: "冷门连载" },
  { value: "36", label: "细分题材" },
  { value: "120万+", label: "同好读者" },
  { value: "12h", label: "同步更新" },
];

const tags = ["暗黑系", "邪典", "重口", "脑洞", "都市怪谈", "末日废土"];

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt="歪歪漫画暗黑猎奇漫画聚合频道首屏背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/60 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-transparent to-background-950/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-28 pb-20">
        <div className="max-w-3xl mx-auto text-center">
          <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-500/40 bg-primary-500/10 text-primary-300 text-xs tracking-widest mb-6">
            <i className="ri-ghost-smile-line text-sm"></i>
            猎奇邪典 · 冷门脑洞 · 聚合阅读
          </p>

          <h1 className="font-heading text-4xl md:text-6xl font-black leading-tight text-foreground-950 mb-6">
            推开一扇门
            <br className="md:hidden" />
            <span className="text-primary-400"> 走进另一个世界</span>
          </h1>

          <p className="text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl mx-auto mb-8">
            歪歪漫画猎奇频道聚合全网<b className="text-foreground-500 font-medium">暗黑系</b>、
            <b className="text-foreground-500 font-medium">邪典</b>、
            <b className="text-foreground-500 font-medium">重口</b>及脑洞大开的小众漫画资源，
            完整连载与分类整理一站看全，满足你对非常规故事的全部阅读需求。
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tags.map((t) => (
              <span
                key={t}
                className="px-3 py-1 rounded-md bg-background-200/60 border border-background-300/40 text-foreground-500 text-xs"
              >
                {t}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
            <a
              href="#hot"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-600 hover:bg-primary-500 text-foreground-950 font-medium text-sm transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line text-base"></i>
              立即开始阅读
            </a>
            <a
              href="#category"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-200/40 border border-background-400/40 hover:bg-background-200/60 text-foreground-200 font-medium text-sm transition-colors whitespace-nowrap"
            >
              <i className="ri-archive-2-line text-base"></i>
              浏览全部题材
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl mx-auto">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg bg-background-200/30 border border-background-300/30 px-3 py-4 text-center"
              >
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-400">
                  {s.value}
                </p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <a
        href="#category"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 w-9 h-9 rounded-full border border-background-400/40 flex items-center justify-center text-foreground-400 animate-bounce hover:text-foreground-950 hover:border-primary-500 transition-colors"
      >
        <i className="ri-arrow-down-s-line text-xl"></i>
      </a>
    </section>
  );
}